import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material-nextjs/esm/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/CssBaseline/CssBaseline.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Noto_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-noto-sans\"}],\"variableName\":\"notoSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ApolloWrapper"] */ "/app/src/common/components/ApolloWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/common/components/CloudWatchRum.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/theme/AppTheme.tsx");
